const state = {
  data: JSON.parse(localStorage.getItem('tickets')),
};

const getters = {};

const actions = {};

const mutations = {
  UPDATE_TICKET(state, payload) {
    state.data = payload.data;
    localStorage.setItem('tickets', JSON.stringify(payload.data));
  },

  CLEAR_TICKET(state) {
    if (state.data) {
      state.data = null;
      localStorage.setItem('tickets', JSON.stringify(null));
    }
  },

  DELETE_TICKET(state, dialog) {
    Vue.delete(state.dialogs, dialog);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
